import { Slider } from "components/common/Slider/Slider";
import { Translate } from "components/common/Translate/Translate";
import { MAX_RESIZE_PERCENTAGE } from "store/features/resizeEditor/reducers/resize/setPercentage";
import { usePercentage } from "./usePercentage";
import { UnitDropDown } from "components/modules/Editors/ImageResizer/EditSettings/ResizeSettings/Size/Size";
import { useUnit } from "components/modules/Editors/BulkResizer/EditSettings/ResizeSettings/Unit/useUnit";

export const Percentage = () => {
    const { handleChange, percentage } = usePercentage();
    const { unit, handleChange: handleUnitChange } = useUnit();

    return (
        <div className="flex flex-col gap-4">
            <div className="capitalize font-semibold">
                <Translate keyName="size" />
            </div>
            <div className="flex items-center gap-4 dark:bg-darkSurface-200 border border-irGray-400 dark:border-darkSurface-100 px-4 pt-4 pb-5 rounded-xl"
            data-testid="as-percentage-slider-main"
            >
                <div className="flex-grow" data-testid="as-percentage-slider-line">
                    <Slider
                        min={0}
                        max={MAX_RESIZE_PERCENTAGE}
                        defaultValue={percentage}
                        handleChange={handleChange}
                        step={1}
                    />
                </div>
                <div className="mt-1">{percentage}%</div>
            </div>
            <div className="flex items-center justify-between text-sm ">
                <span className="text-irGray-500">
                    <Translate
                        keyName="as-percentage-helper-text"
                        variables={{
                            percentage,
                        }}
                    />
                </span>

                <UnitDropDown unit={unit} handleChange={handleUnitChange} />
            </div>
        </div>
    );
};
